import { Pipe, PipeTransform } from '@angular/core';
import { ModoBusqueda } from './shared/modo-busqueda.enum';

@Pipe({
  name: 'filtroArticulo'
})
export class FiltroArticuloPipe implements PipeTransform {

    transform(items: any[], _cadena: string, _modo : ModoBusqueda): any[] 
    {
        console.log( "Filtro" );
        console.log( _cadena, _modo );
        if (!items || !_cadena) 
        {
          return items;
        }

        switch (_modo) 
        {
            case ModoBusqueda.codigoExacto:
                return items.filter(item => item.codigo.toLowerCase().trim() == _cadena.toLowerCase().trim());

            case ModoBusqueda.codigoDescripcion:
                return items.filter(item => ( item.codigo.toLowerCase().includes(_cadena.toLowerCase()) || item.descripcion.toLowerCase().includes(_cadena.toLowerCase()) ) );

            case ModoBusqueda.empieza:
                return items.filter(item => ( item.descripcion.toLowerCase().startsWith(_cadena.toLowerCase()) ) );
                
            case ModoBusqueda.contiene:
                return items.filter(item => ( item.descripcion.toLowerCase().includes(_cadena.toLowerCase()) ) );

            case ModoBusqueda.acaba:
                return items.filter(item => ( item.descripcion.toLowerCase().endsWith(_cadena.toLowerCase()) ) );
        }
                
      }

}
